import React, { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import FormWizard from './components/FormWizard';
import GDPRPopup from './components/GDPRPopup';
import logo from '../src/assets/logo/424b.png';
import './App.css';

function App() {
  const [currentStep, setCurrentStep] = useState(1);
  const [showGDPR, setShowGDPR] = useState(false);
  const [gdprAccepted, setGdprAccepted] = useState(false);
  const [formData, setFormData] = useState({
    requesterType: 'patient',
    requestType: '',
    identityMethod: '',
    identityDocument: null,
    patientAmka: '',
    patientName: '',
    periodOfHospitalization: '',
    clinic: '',
    visitDate: '',
    examDate: '',
    surgeryDate: '',
    admissionDate: '',
    timePeriod: '',
    examTypes: [],
    examDates: {},
    requestDetails: '',
    comments: '',
    email: '',
    phone: '',
    familyCertificate: null,
    willCertificate: null,
    attachments: []
  });

  const updateFormData = (newData) => {
    setFormData(prev => ({ ...prev, ...newData }));
  };

  const resetForm = () => {
    setFormData({
      requesterType: 'patient',
      requestType: '',
      identityMethod: '',
      identityDocument: null,
      patientAmka: '',
      patientName: '',
      periodOfHospitalization: '',
      clinic: '',
      visitDate: '',
      examDate: '',
      surgeryDate: '',
      admissionDate: '',
      timePeriod: '',
      examTypes: [],
      examDates: {},
      requestDetails: '',
      comments: '',
      email: '',
      phone: '',
      familyCertificate: null,
      willCertificate: null,
      attachments: []
    });
    setCurrentStep(1);
  };

  // Show GDPR popup on every visit
  useEffect(() => {
    setShowGDPR(true);
  }, []);

  const handleGDPRAccept = () => {
    setGdprAccepted(true);
  };

  const handleGDPRClose = () => {
    setShowGDPR(false);
  };

  return (
    <div className="App">
      <div className="container">
        <div className="header">
          <div className="header-content">
            <img src={logo} alt="424 ΓΣΝΕ Logo" className="header-logo" />
            <div className="header-text">
              <h1>Αίτηση χορήγησης ιατρικών εγγράφων</h1>
              <p>424 Γενικό Στρατιωτικό Νοσοκομείο Εκπαιδεύσεως</p>
            </div>
          </div>
        </div>
        
        {gdprAccepted ? (
          <FormWizard
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            formData={formData}
            updateFormData={updateFormData}
            resetForm={resetForm}
          />
        ) : (
          <div className="gdpr-blocked">
            <div className="gdpr-blocked-content">
              <h2>Πολιτική Προστασίας Δεδομένων</h2>
              <p>
                Για να συνεχίσετε με την υποβολή αιτήματος, παρακαλώ διαβάστε και 
                αποδεχτείτε την πολιτική προστασίας προσωπικών δεδομένων.
              </p>
              <button 
                className="btn btn-primary"
                onClick={() => setShowGDPR(true)}
              >
                Διαβάστε την Πολιτική
              </button>
            </div>
          </div>
        )}
      </div>
      
      <GDPRPopup
        isOpen={showGDPR}
        onClose={handleGDPRClose}
        onAccept={handleGDPRAccept}
      />
      
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#3498db',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#e74c3c',
              secondary: '#fff',
            },
          },
        }}
      />
    </div>
  );
}

export default App;
